var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2MehHilite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "hilite",
    fill: "#4A90E2",
    cx: 34,
    cy: 34,
    r: 33
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 34,
    cy: 34,
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0001011,55.0189474 C22.3790484,55.0189474 12.9811537,45.6210526 12.9811537,34 C12.9811537,22.3789474 22.3790484,12.9810526 34.0001011,12.9810526 C45.6211537,12.9810526 55.0190484,22.3789474 55.0190484,34 C55.0190484,45.6210526 45.6211537,55.0189474 34.0001011,55.0189474 M34.0001011,10 C20.7622063,10 10.0001011,20.7621053 10.0001011,34 C10.0001011,47.2378947 20.7622063,58 34.0001011,58 C47.2379958,58 58.0001011,47.2378947 58.0001011,34 C58.0001011,20.7621053 47.2379958,10 34.0001011,10 M45.2673684,41.9809516 C46.0757895,41.9809516 46.7831579,42.6377937 46.7831579,43.4967411 C46.7831579,44.3556884 46.0757895,45.0125305 45.2673684,45.0125305 L45.2673684,45.0125305 L22.7326316,45.0125305 C21.8736842,45.0125305 21.2168421,44.3556884 21.2168421,43.4967411 C21.2168421,42.6377937 21.9242105,41.9809516 22.7326316,41.9809516 L22.7326316,41.9809516 Z M22.88,30 C24.4705684,30 25.76,31.2894316 25.76,32.88 C25.76,34.4710737 24.4705684,35.76 22.88,35.76 C21.2894316,35.76 20,34.4710737 20,32.88 C20,31.2894316 21.2894316,30 22.88,30 Z M45.88,30 C47.4705684,30 48.76,31.2894316 48.76,32.88 C48.76,34.4710737 47.4705684,35.76 45.88,35.76 C44.2894316,35.76 43,34.4710737 43,32.88 C43,31.2894316 44.2894316,30 45.88,30 Z",
    id: "Fill-1",
    fill: "#858585"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2MehHilite);
export default __webpack_public_path__ + "static/media/2 Meh_hilite.0b1b044841e1e18d56ef16ed7bf2cdb9.svg";
export { ForwardRef as ReactComponent };